import { render, staticRenderFns } from "./ProfileChanges.vue?vue&type=template&id=2dbe0277&scoped=true"
import script from "./ProfileChanges.vue?vue&type=script&lang=js"
export * from "./ProfileChanges.vue?vue&type=script&lang=js"
import style0 from "./ProfileChanges.vue?vue&type=style&index=0&id=2dbe0277&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dbe0277",
  null
  
)

export default component.exports